import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GTMService } from '../gtm.service';
import { LCOnboardingTrackEvent } from '../types/lc-onboarding-track-event';
import { BILINGUAL_FALLBACK_OPTIONS } from './consts/bilingual-fallback-options';
import { TEACHER_OPTIONS } from './consts/teacher-options';
import { TeacherSwitchModalComponent } from './teacher-switch-modal/teacher-switch-modal.component';
import { BilingualFallbackOption } from './types/bilingual-fallback-opt.type';
import { TeacherOption } from './types/teacher-opt.type';
@Component({
  selector: 'lp2-teacher-switch',
  templateUrl: './teacher-switch.component.html',
  styleUrls: ['./teacher-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TeacherSwitchComponent,
      multi: true,
    },
  ],
})
export class TeacherSwitchComponent implements ControlValueAccessor {
  private static readonly MODAL_CLASS = 'teacher-switch-modal-window';

  @Input() public teacherOptions: TeacherOption[] = TEACHER_OPTIONS;
  @Input() public bilingualFallbackOptions: BilingualFallbackOption[] = BILINGUAL_FALLBACK_OPTIONS;
  @Input() public enabled: boolean;

  public selectedType: TeacherOption['value'];
  public selectedBilingualFallback: BilingualFallbackOption['value'];

  public teacherDetails: TeacherOption['details'];

  public onChange: any = () => {};
  public onTouch: any = () => {};

  public constructor(private gtmService: GTMService, private ngbModal: NgbModal, private cdRef: ChangeDetectorRef) {}

  public writeValue({teacherType, bilingualFallback}: { teacherType: TeacherOption['value']; bilingualFallback?: BilingualFallbackOption['value']}): void {
    if (teacherType) {
      this.selectedType = teacherType;
      this.selectedBilingualFallback = bilingualFallback;
      this.setTeacherOptDetails();
    }
  }

  public setTeacherOptDetails(): void {
    this.teacherDetails = this.teacherOptions.find((opt: TeacherOption) => {
      return opt.value === this.selectedType;
    }).details;
  }

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public registerOnTouched(onTouched: Function) {
    this.onTouch = onTouched;
  }

  public openModal(): void {
    this.gtmService.sendGA4Event(LCOnboardingTrackEvent.LC_CHANGE_TYPE_OF_TEACHER_CLICK);
    const modalRef: NgbModalRef = this.ngbModal.open(TeacherSwitchModalComponent, {
      windowClass: TeacherSwitchComponent.MODAL_CLASS,
      centered: true,
    });
    if (this.selectedType) {
      modalRef.componentInstance.selectedOption = this.selectedType;
    }
    if (this.selectedBilingualFallback) {
      modalRef.componentInstance.selectedBilingualFallback = this.selectedBilingualFallback;
    }
    modalRef.componentInstance.teacherOpts = this.teacherOptions;
    modalRef.componentInstance.bilingualFallbackOpts = this.bilingualFallbackOptions;
    modalRef.result.then((values: {teacherType?: TeacherOption['value'], bilingualFallback?: BilingualFallbackOption['value']}) => {
      if (values && (values.teacherType || values.bilingualFallback)) {
        this._updateValues(values);
      } else {
        this.gtmService.sendGA4Event(LCOnboardingTrackEvent.LC_CHANGE_TYPE_OF_TEACHER_X);
      }
    });
  }

  private _updateValues(values:{teacherType?: TeacherOption['value'], bilingualFallback?: BilingualFallbackOption['value']}): void {
    this.selectedType = values.teacherType
    this.selectedBilingualFallback = values.bilingualFallback;
    this.onChange(values);
    this.setTeacherOptDetails();
    this.cdRef.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/teacher-switch/teacher-switch.component.ts